import { render } from "./WeeklyRatingChart.vue?vue&type=template&id=33b909ae&ts=true"
import script from "./WeeklyRatingChart.vue?vue&type=script&lang=ts"
export * from "./WeeklyRatingChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__